import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCustomerImageTabsAlertsQueryParamType,
  GetCulpritCustomerImageTabsAlertsQueryResponseQueryType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImageTabsAlerts/getCulpritCustomerImageTabsAlertsQuery.type';

export const getCulpritCustomerImageTabsAlertsQueryFunctions = (
  params: GetCulpritCustomerImageTabsAlertsQueryParamType,
): Promise<GetCulpritCustomerImageTabsAlertsQueryResponseQueryType> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/culprit/images/customer/entry_tabs/alert/`,
  );
